import React, { useEffect, useState } from "react";
import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Footer } from "./partials/Footer";
import {Navbar} from './partials/Navbar';
import RouterPage from "./RouterPage";
import  Sidebar  from "./partials/Sidebar";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'

function getStoredValue(key, fallback) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
}

function clearSession() {
  ["user", "permissions", "branche", "society"].forEach((key) => localStorage.removeItem(key));
  delete axios.defaults.headers.common["x-access-token"];
}

function getStoredPermissions() {
  const permissions = getStoredValue("permissions", []);
  return Array.isArray(permissions) ? permissions : [];
}

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [session, setSession] = useState({
    status: getStoredValue("user", null) ? "checking" : "guest",
    user: null,
    permissions: []
  });

  useEffect(() => {
    const storedUser = getStoredValue("user", null);

    if (!storedUser) {
      clearSession();
      setSession({ status: "guest", user: null, permissions: [] });
      return;
    }

    let active = true;

    axios.get("token").then((response) => {
      if (!active) return;

      if (response.status !== 200 || !response.data?.data) {
        clearSession();
        setSession({ status: "guest", user: null, permissions: [] });
        return;
      }

      const user = response.data.data;
      const permissions = Array.isArray(response.data.permissions)
        ? response.data.permissions
        : getStoredPermissions();
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("permissions", JSON.stringify(permissions));
      axios.defaults.headers.common["x-access-token"] = user.refresh_token || "";
      setSession({ status: "authenticated", user, permissions });
    }).catch(() => {
      if (!active) return;

      clearSession();
      setSession({ status: "guest", user: null, permissions: [] });
      axios.delete("logout").catch(() => {});
    });

    return () => {
      active = false;
    };
  }, []);

  const hasDashboard = session.permissions.some((item) => item.name === "afficher dashboard");
  const dashboardClassName = hasDashboard ? "dashboard" + (sidebarOpen ? " -is-sidebar-open" : "") : "";

  if (session.status === "checking") {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        La Victoire Express...
      </div>
    );
  }

  return (
    <Router> 
          <Navbar user={session.user} permissions={session.permissions} onToggleSidebar={() => setSidebarOpen((isOpen) => !isOpen)} />
          <div className={dashboardClassName} data-x="dashboard" data-x-toggle="-is-sidebar-open">
            {hasDashboard && <Sidebar user={session.user} permissions={session.permissions} />}
            <div className={hasDashboard ? "dashboard__main" : ""}>
                <RouterPage user={session.user} permissions={session.permissions} />
            </div>
          </div>
          <ToastContainer />
          {!session.user && <Footer />}
    </Router>
  );
}

export default App;
